// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LegalInfoPage_legalInfoPage__-pcSp {
  padding: 3rem 0;
  display: flex;
  flex-direction: column;
  gap: 5rem;
}
.LegalInfoPage_legalInfoPage__contentContainer__y66ty {
  gap: 5rem;
}

.LegalInfoPage_legalInfo__yLYOA {
  display: flex;
  flex-direction: column;
  gap: 4rem;
}
.LegalInfoPage_legalInfo__yLYOA h2 {
  font-family: "Montserrat Alternates";
  font-size: 6rem;
}
.LegalInfoPage_legalInfo_docList__teLsW {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.LegalInfoPage_legalInfo_docList_docBlock__6MuIF {
  max-width: 25rem;
}
.LegalInfoPage_legalInfo_docList_docBlock__6MuIF > img {
  width: 100%;
  border-radius: 2rem;
  border: 1px solid #cacaca;
  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.35);
}
.LegalInfoPage_legalInfo_docList_docBlock__6MuIF > a {
  display: flex;
  gap: 1rem;
  color: var(--blue-dark);
  font-size: 1.4rem;
  text-decoration: none;
}

.LegalInfoPage_contacts__wYjRn {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.LegalInfoPage_contacts__wYjRn h3 {
  font-family: "Montserrat Alternates";
  font-size: 2.6rem;
}
.LegalInfoPage_contacts__wYjRn > div {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 50rem;
}
.LegalInfoPage_contacts__wYjRn > div > div {
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
  align-items: center;
}

@media (max-width: 600px) {
  .LegalInfoPage_legalInfo__yLYOA > h2 {
    align-self: center;
    font-size: 8.125vw;
  }
  .LegalInfoPage_legalInfo_docList__teLsW {
    justify-content: center;
    text-align: center;
  }
  .LegalInfoPage_contacts__wYjRn > div {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/LegalInfoPage/LegalInfoPage.module.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACD;AACC;EACC,SAAA;AACF;;AAGA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AAAD;AAEC;EACC,oCAAA;EACA,eAAA;AAAF;AAGC;EACC,aAAA;EACA,eAAA;EACA,SAAA;AADF;AAGE;EACC,gBAAA;AADH;AAEG;EACC,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,+CAAA;AAAJ;AAEG;EACC,aAAA;EACA,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,qBAAA;AAAJ;;AAMA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AAHD;AAKC;EACC,oCAAA;EACA,iBAAA;AAHF;AAMC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAJF;AAME;EACC,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AAJH;;AAUA;EAEE;IACC,kBAAA;IACA,kBAAA;EARD;EAWA;IACC,uBAAA;IACA,kBAAA;EATD;EAcA;IACC,0BAAA;EAZD;AACF","sourcesContent":[".legalInfoPage {\n\tpadding: 3rem 0;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 5rem;\n\n\t&__contentContainer {\n\t\tgap: 5rem;\n\t}\n}\n\n.legalInfo {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 4rem;\n\n\th2 {\n\t\tfont-family: 'Montserrat Alternates';\n\t\tfont-size: 6rem;\n\t}\n\n\t&_docList {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tgap: 1rem;\n\n\t\t&_docBlock {\n\t\t\tmax-width: 25rem;\n\t\t\t& > img {\n\t\t\t\twidth: 100%;\n\t\t\t\tborder-radius: 2rem;\n\t\t\t\tborder: 1px solid #cacaca;\n\t\t\t\tbox-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.35);\n\t\t\t}\n\t\t\t& > a {\n\t\t\t\tdisplay: flex;\n\t\t\t\tgap: 1rem;\n\t\t\t\tcolor: var(--blue-dark);\n\t\t\t\tfont-size: 1.4rem;\n\t\t\t\ttext-decoration: none;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.contacts {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 1rem;\n\n\th3 {\n\t\tfont-family: 'Montserrat Alternates';\n\t\tfont-size: 2.6rem;\n\t}\n\n\t& > div {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 1rem;\n\t\tmax-width: 50rem;\n\n\t\t& > div {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\tgap: 1.5rem;\n\t\t\talign-items: center;\n\t\t}\n\t}\n}\n\n// Mobile\n@media (max-width: 600px) {\n\t.legalInfo {\n\t\t& > h2 {\n\t\t\talign-self: center;\n\t\t\tfont-size: calc(26 * 100vw / 320);\n\t\t}\n\n\t\t&_docList {\n\t\t\tjustify-content: center;\n\t\t\ttext-align: center;\n\t\t}\n\t}\n\n\t.contacts {\n\t\t& > div {\n\t\t\tgrid-template-columns: 1fr;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"legalInfoPage": `LegalInfoPage_legalInfoPage__-pcSp`,
	"legalInfoPage__contentContainer": `LegalInfoPage_legalInfoPage__contentContainer__y66ty`,
	"legalInfo": `LegalInfoPage_legalInfo__yLYOA`,
	"legalInfo_docList": `LegalInfoPage_legalInfo_docList__teLsW`,
	"legalInfo_docList_docBlock": `LegalInfoPage_legalInfo_docList_docBlock__6MuIF`,
	"contacts": `LegalInfoPage_contacts__wYjRn`
};
export default ___CSS_LOADER_EXPORT___;
